import React, { useState } from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { useLocation } from 'react-router-dom';

import logo1 from "../images/logo.png";
import logowhite from "../images/logo-white.png";
import { NavLink } from 'react-router-dom';
import { LuMenu } from "react-icons/lu";
import { AnimatePresence, motion } from 'framer-motion';

import { FaHome } from "react-icons/fa";
import { MdPedalBike } from "react-icons/md";
import { FaStore } from "react-icons/fa";
import { FaCogs } from "react-icons/fa";
import Ridley from "./Ridley-icon";
import { IoMdClose } from "react-icons/io";
import { getLocalizedText } from '../utils/textLocalization';

function App({mode}) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Get localized text
  const homeText = getLocalizedText('nav.home');
  const bikesText = getLocalizedText('nav.bikes');
  const aboutText = getLocalizedText('nav.about');
  const dealersText = getLocalizedText('nav.dealers');
  const configuratorText = getLocalizedText('nav.configurator');

  const mobile = () => {
    setOpen(!open);
  };

  const handleScroll = (e) => {

    if (open) {setOpen(false)}

    const hash = e.currentTarget.hash.substring(1);
    setTimeout(() => {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div>
      <header id="banner" className={`scrollto clearfix`} data-enllax-ratio="0.5">
        <div id="header" className={`nav-collapse ${location.pathname === "/konfigurator"  && "white-stripe-topbar"}`}>
          <div className={`row clearfix`}>
            <div className="header-remake-background">
              <div id="logo">
                <NavLink to="/">
                  <img src={mode === "light" ? logo1 : location.pathname === "/konfigurator" ? logo1 : logowhite} id="banner-logo" alt="Ridley logo" />
                </NavLink>
              </div>

              <nav id="nav-main" className="barlow-semibold nav-big shadow">
                <ul>
                  <li>
                    <NavLink className={location.pathname === "/konfigurator" ? "pointer" : "pointer white-text"} to="/">{homeText}</NavLink>
                  </li>
                  <li>
                    <NavLink className={location.pathname === "/konfigurator" ? "pointer" : "pointer white-text"} to="/#kola" onClick={handleScroll}>{bikesText}</NavLink>
                  </li>
                  <li>
                    <NavLink className={location.pathname === "/konfigurator" ? "pointer" : "pointer white-text"} to="/o-ridley">{aboutText}</NavLink>
                  </li>
                  <li>
                    <NavLink className={location.pathname === "/konfigurator" ? "pointer" : "pointer white-text"} to="/prodejci">{dealersText}</NavLink>
                  </li>
                  <li>
                    <NavLink className={location.pathname === "/konfigurator" ? "pointer konfigurator-topbar" : "pointer white-text konfigurator-topbar"} to="/konfigurator">{configuratorText}</NavLink>
                  </li>
                </ul>
              </nav>

              {open ? <>
              <button onClick={mobile} className="mobileMenu-open" id="mobile-button"><IoMdClose /></button>
              </>:<>
              <button onClick={mobile} className={location.pathname === "/konfigurator" ? "mobileMenu black-text" : "mobileMenu white-text"} id="mobile-button"><LuMenu /></button>
              </>}

              <AnimatePresence>
                {open && (
                  <motion.div
                    className="mobileMenu-container-rework"
                    id="mobile-container"
                    key="mobile-menu"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    
                  <motion.div
                    id="mobile-container"
                    key="mobile-menu"
                    initial={{ opacity: 0, x: 0, width: "0%" }}
                    animate={{ opacity: 1, x: 0, width: "90%" }}
                    exit={{ opacity: 0, x: 0, width: "0%" }}
                    transition={{ duration: 0.3 }}
                  >
                    <img src={logo1} alt="Ridley logo" id="mobile-logo" />
                    <NavLink to="/" onClick={() => setOpen(false)}><FaHome /> {homeText}</NavLink>
                    <NavLink to="/#kola" className="pointer" onClick={handleScroll}><MdPedalBike /> {bikesText}</NavLink>
                    <NavLink to="/o-ridley" className="pointer" onClick={() => setOpen(false)}><Ridley /> {aboutText}</NavLink>
                    <NavLink to="/prodejci" className="pointer" onClick={() => setOpen(false)}><FaStore /> {dealersText}</NavLink>
                    <NavLink className="pointer" to="/konfigurator"><FaCogs /> <label className="konfigurator-topbar">{configuratorText}</label></NavLink>
                    <span />
                    </motion.div>
                  </motion.div> 
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
